import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import GameMap from "./logic/GameMap";
import charSprite from "../../assets/images/characters/Pokemon-Red.png";
import api from "../../api";
import HalloweenShopModal from "../../components/Modals/HalloweenShopModal";

const config = {
  id: 3,
  image: "/Maps/Halloween_Event.png",
  over: null, // No overlay image
  width: 800,
  height: 600,
  tileSize: 8,
  characterSprite: charSprite,
  lureImages: {
    lureImg: "/lure.png",
    superLureImg: "/super-lure.png",
    ultraLureImg: "/ultra-lure.png",
  },
  viewport: {
    width: 336,
    height: 240,
  },
  initialPlayer: {
    x: 400, // Center of the map
    y: 300, // Center of the map
    direction: "down",
    step: 0,
  },
  collisionAreas: [
    // Add collision areas for walls, trees, etc.
    // Example: { x: 0, y: 0, width: 32, height: 600 } // Left wall
    {x: 480, y: 200, width: 61, height: 68, "padX": 2, "padY": 8 },
    {x: 386, y: 200, width: 61, height: 68, "padX": 2, "padY": 8 },
    {x: 480, y: 345, width: 61, height: 68, "padX": 2, "padY": 8 },
    {x: 420, y: 345, width: 61, height: 68, "padX": 2, "padY": 8 },
    {x: 545, y: 345, width: 30, height: 200, "padX": 2, "padY": 8 },
    {x: 545, y: 10, width: 30, height: 335, "padX": 2, "padY": 8 },
    {x: 320, y: 500, width: 250, height: 45, "padX": 2, "padY": 8 },
    {x: 5, y: 500, width: 250, height: 45, "padX": 2, "padY": 8 },
    {x: 5, y: 500, width: 250, height: 45, "padX": 2, "padY": 8 },
    {x: 30, y: 468, width: 32, height: 25, "padX": 2, "padY": 8 },
    {x: 1, y: 5, width: 32, height: 600, "padX": 15, "padY": 12 },
    {x: 30, y: 310, width: 52, height: 60, "padX": 19, "padY": 12 },
    {x: 208, y: 310, width: 52, height: 60, "padX": 25, "padY": 18 },
    {x: 30, y: 200, width: 65, height: 71, "padX": 19, "padY": 12 },
    {x: 128, y: 200, width: 65, height: 71, "padX": 19, "padY": 12 },
    {x: 30, y: 28, width: 82, height: 71, "padX": 19, "padY": 12 },
    {x: 115, y: 26, width: 60, height: 71, "padX": 19, "padY": 12 },
    {x: 178, y: 26, width: 60, height: 71, "padX": 6, "padY": 12 },
    {x: 270, y: 100, width: 48, height: 58, "padX": 6, "padY": 12 },
    {x: 355, y: 26, width: 60, height: 71, "padX": 6, "padY": 12 },
    {x: 418, y: 26, width: 60, height: 71, "padX": 6, "padY": 12 },
    {x: 482, y: 26, width: 60, height: 71, "padX": 6, "padY": 12 },
    {x: 30, y: -8, width: 600, height: 20, "padX": 6, "padY": 12 },

  ],
  teleportZones: [
  ],
  battleBackground: "/Battle/LowVisBG.png",
  // Special Halloween-themed Pokemon
  npcs: [
       {
       id: "Portal-Shop",
       x: 288,
       y: 150,
       width: 16,
       height: 24,
       sprite: "/Trainers/portal-shop.png",
       type: "event"
     },
  ],
};

export default function HalloweenEvent() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [accessGranted, setAccessGranted] = useState(false);
  const [message, setMessage] = useState("Checking Halloween event access...");
  const [eventShopOpen, setEventShopOpen] = useState(false);
  const [playerPos, setPlayerPos] = useState({ x: 0, y: 0 });
  
  // Handle NPC interaction
  const handleNpcInteraction = (npcId, playerPosition) => {
    setPlayerPos(playerPosition);
    
    // For Portal-Shop NPC, open the Halloween shop modal
    if (npcId === "Portal-Shop") {
      setEventShopOpen(true);
    }
  };

  // Check if the user has access to the Halloween event
  useEffect(() => {
    const checkAccess = async () => {
      try {
        const response = await api.get("/v1/halloween-access", { withCredentials: true });
        
        if (response.data.access) {
          setAccessGranted(true);
        } else {
          // No access, redirect to main map after showing message
          setMessage(response.data.message || "Halloween event is not currently accessible.");
          setTimeout(() => {
            navigate("/map/LowVisibility");
          }, 3000);
        }
      } catch (error) {
        console.error("Error checking Halloween access:", error);
        setMessage("Error checking event access. Redirecting to main map...");
        setTimeout(() => {
          navigate("/map/LowVisibility");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    checkAccess();

    // Set up interval to periodically check if portal is still active
    const checkInterval = setInterval(async () => {
      try {
        const response = await api.get("/v1/halloween-access", { withCredentials: true });
        
        if (!response.data.access && accessGranted) {
          // Portal expired while user was in the map
          setAccessGranted(false);
          setMessage("Halloween portal has closed! Returning to main map...");
          setTimeout(() => {
            navigate("/map/LowVisibility");
          }, 3000);
        }
      } catch (error) {
        console.error("Error checking Halloween access:", error);
      }
    }, 30000); // Check every 30 seconds

    return () => clearInterval(checkInterval);
  }, [navigate, accessGranted]);

  // Show loading or error message
  if (loading || !accessGranted) {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#1a1a1a",
        color: "#ff6600",
        fontFamily: "'Creepster', cursive",
        textAlign: "center",
        padding: "20px"
      }}>
        <h2 style={{ fontSize: "2rem", marginBottom: "20px" }}>{message}</h2>
        {loading && (
          <div style={{
            width: "50px",
            height: "50px",
            border: "5px solid rgba(255, 102, 0, 0.3)",
            borderRadius: "50%",
            borderTop: "5px solid #ff6600",
            animation: "spin 1s linear infinite"
          }} />
        )}
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // If access is granted, render the map
  return (
    <>
      <GameMap 
        config={config} 
        onNpcInteraction={handleNpcInteraction}
      />
      
      {/* Halloween Event Shop Modal */}
      <HalloweenShopModal
        isOpen={eventShopOpen}
        toggle={() => setEventShopOpen(false)}
        shopId={2} // Witchveil Market shop ID
        playerPos={playerPos}
        spawnText={(text, x, y, color, imageUrl) => {
          // Forward spawnText to GameMap if needed
          if (window.spawnFloatingText) {
            window.spawnFloatingText(text, x, y, color, imageUrl);
          }
        }}
      />
    </>
  );
}
